const getDashboardColorClasses = (score: number | null) => {
  if (score === null || score === undefined)
    return {
      bg: "bg-gray-500",
      text: "text-gray-600",
      lighter: "bg-gray-50",
      border: "border-gray-100",
      progress: "bg-gray-500",
    };
  if (score >= 80)
    return {
      bg: "bg-emerald-500",
      text: "text-emerald-600",
      lighter: "bg-emerald-50",
      border: "border-emerald-100",
      progress: "bg-emerald-500",
    };
  if (score >= 30)
    return {
      bg: "bg-amber-500",
      text: "text-amber-600",
      lighter: "bg-amber-50",
      border: "border-amber-100",
      progress: "bg-amber-500",
    };
  return {
    bg: "bg-red-500",
    text: "text-red-600",
    lighter: "bg-red-50",
    border: "border-red-100",
    progress: "bg-red-500",
  };
};

export default getDashboardColorClasses;